"use client";

import React, { useRef, useEffect } from "react";
import parser from "html-react-parser";
import buttonHelper from "./../helpers/buttonHelper";
import stringHelpers from "../helpers/stringHelpers";
import Accordion from "@/components/Accordion";
import Bookmark from "./Bookmark";
import Button from "@/components/Button";
import Cards from "@/components/Cards";
import CardItem from "@/components/CardsItem";
import DividerBar from "@/components/DividerBar";
import Heading from "@/components/Heading";
import InlineImage from "@/components/Image";
import Tabs from "@/components/Tabs";
import Text from "@/components/Text";
import TextWithAside from "@/components/TextWithAside";
import VimeoPlayer from "./VimeoPlayer";

const AccordionItem = ({
  accordionHtmlHack,
  activeFacet,
  buttonPage,
  buttonText,
  buttonUrl,
  cardItems,
  handleFilter,
  onClick,
  id,
  itemId,
  items,
  isActive,
  menu,
  subtitle,
  targetBlank,
  text,
  title,
  videoUrl,
  videoUrl2,
  nested,
  name,
}) => {
  const contentRef = useRef(null);

  if (accordionHtmlHack) {
    description = description.replace(
      /(<ul class="accordion tps-accordion)/gm,
      `$1 htmlhack`
    );
  }

  useEffect(() => {
    if (accordionHtmlHack) {
      const interval = setInterval(() => {
        if (window.$ && window.$.fn && window.$.fn.foundation) {
          // Destroy Foundation accordion instance on your custom accordions
          $("ul.tps-accordion.htmlhack[data-accordion]").each(function () {
            try {
              $(this).foundation("destroy");
              console.log("Foundation accordion destroyed:", this);
            } catch (err) {
              console.warn("No Foundation accordion to destroy:", this, err);
            }
          });
        } else {
          // Optionally, re-init Foundation if you toggle back
          if (window.$ && window.$.fn && window.$.fn.foundation) {
            $("ul.tps-accordion[data-accordion]").foundation();
          }
        }
      }, 200);
      return () => clearInterval(interval);
    }
  }, [accordionHtmlHack]);

  useEffect(() => {
    // Poll until jQuery + Foundation are available
    const interval = setInterval(() => {
      if (window.$ && window.$.fn && window.$.fn.foundation) {
        clearInterval(interval);

        // Init only accordion widgets; avoid document-wide re-init that duplicates off-canvas overlays
        window.$("ul.tps-accordion[data-accordion]").foundation();

        // Prevent bubbling for nested accordions
        const handleClick = (e) => e.stopPropagation();
        window
          .$(document)
          .on("click", ".nested-accordion .accordion-title", handleClick);

        // Cleanup
        return () => {
          window
            .$(document)
            .off("click", ".nested-accordion .accordion-title", handleClick);
        };
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const buttonPageUrl = !!buttonPage
    ? buttonHelper.findSlugPath(menu, buttonPage.data?.attributes?.title)
    : null;

  const uniqueItemIds =
    name ||
    `${title
      ?.trim()
      .replace(/[\s?!'/()\[\]{}.$]+/g, "")
      .replace(/[,\.|:;]+/g, "-")
      .replace(/[&]+/g, "-and-")}-${id}`;

  return (
    <li
      className={`accordion-item tps-accordion-item ${
        isActive ? "is-active" : ""
      }`}
      data-accordion-item=""
      data-index={id}
      role="presentation"
    >
      <a
        name={uniqueItemIds} // anchor name
        onClick={onClick}
        className="accordion-title"
        aria-controls={uniqueItemIds}
        role="tab"
        id={id}
        aria-expanded={isActive ? "true" : "false"}
        aria-selected={isActive ? "true" : "false"}
      >
        {title && title}
      </a>
      <div
        className="accordion-content"
        data-tab-content=""
        id={uniqueItemIds}
        role="tabPanel"
        aria-labelledby={`${uniqueItemIds}-label`}
        aria-hidden={isActive ? "false" : "true"}
        ref={contentRef}
      >
        <div
          className="accordion-content-inner"
          style={{ paddingTop: "20px", paddingBottom: "20px" }}
        >
          {items &&
            items.length > 0 &&
            items.map((item, index) => {
              return (
                <div
                  key={index}
                  className="facet-item"
                  onClick={() => handleFilter(itemId, item.item_name)}
                >
                  <a
                    href="#"
                    className={`facet search-filter-options ${
                      activeFacet && activeFacet.includes(item.item_name)
                        ? "active-facet"
                        : ""
                    }`}
                  >
                    {item.item_name}
                    {!!item.numberOfUsing && (
                      <span className="facet-count">
                        ({item.numberOfUsing})
                      </span>
                    )}
                  </a>
                </div>
              );
            })}
          {subtitle && subtitle}
          {text && parser(stringHelpers.imagePathReplace(text))}
          {cardItems && (
            <div
              className="tps-card-listing tps-related-pages-cards tps-related-pages grid-x grid-margin-x grid-margin-y small-up-1 medium-up-2 large-up-4 align-"
              style={{ width: "auto" }}
            >
              {" "}
              {cardItems.map(
                (cardItem, index2) =>
                  cardItem.attachToItem === id + 1 && (
                    <CardItem
                      key={index2}
                      buttonPage={cardItem.buttonPage}
                      buttonPage2={cardItem.buttonPage2}
                      buttonText={cardItem.buttonText}
                      buttonText2={cardItem.buttonText2}
                      date={cardItem.date}
                      image={cardItem.image?.data?.attributes}
                      menu={menu}
                      fromPage={
                        cardItem?.page?.data?.attributes ||
                        cardItem?.news?.data?.attributes ||
                        cardItem?.course?.data?.attributes ||
                        cardItem?.concert?.data?.attributes
                      }
                      page={cardItem?.page}
                      news={cardItem?.news}
                      course={cardItem?.course}
                      concert={cardItem?.concert}
                      shortText={cardItem.shortText}
                      title={cardItem.title}
                      target={cardItem.target}
                      target2={cardItem.target2}
                      url={cardItem.url}
                      url2={cardItem.url2}
                    />
                  )
              )}
            </div>
          )}
          {videoUrl && <VimeoPlayer videoUrl={videoUrl} />}
          {videoUrl2 && <VimeoPlayer videoUrl={videoUrl2} />}
          {buttonText && (
            <a
              href={buttonUrl || buttonPageUrl || "#"}
              target={`${!!targetBlank ? "_blank" : "_self"}`}
              className="button"
            >
              {buttonText && buttonText}
            </a>
          )}
          {nested?.data?.attributes.components?.length &&
            nested?.data?.attributes?.publishedAt !== null && (
              <>
                {nested.data.attributes.components?.map((c, index) => {
                  switch (c.__component) {
                    case "page.text":
                      return (
                        <Text
                          key={index}
                          text={c?.text}
                          withinContainer={c?.withinContainer}
                          displayAsInlineBlock={c?.displayAsInlineBlock}
                          accordionHtmlHack={c?.accordionHtmlHack}
                        />
                      );
                    case "page.text-with-aside":
                      return (
                        <TextWithAside
                          key={index}
                          text={c?.text}
                          asides={c?.asides}
                        />
                      );
                    case "page.bookmark":
                      return <Bookmark key={index} name={c.name} />;
                    case "page.divider-brick":
                      return (
                        <DividerBar
                          key={index}
                          size={c.size}
                          withoutMargins={c.withoutMargins}
                        />
                      );
                    case "page.button":
                      return (
                        <Button
                          align={c.align}
                          buttonClasses={c?.buttonClasses}
                          buttonColor={c?.buttonColor}
                          buttonLarge={c?.buttonLarge}
                          buttonsPositioning={c?.buttonsPositioning}
                          contentBefore={c?.ContentBefore}
                          filled={c?.filled}
                          key={index}
                          menu={menu}
                          news={c?.news}
                          page={c?.page}
                          concert={c?.concert}
                          course={c?.course}
                          targetBlank={c?.targetBlank}
                          text={c.text}
                          url={c.url}
                          withinContainer={c?.withinContainer}
                        />
                      );
                    case "page.accordion":
                      return (
                        <Accordion
                          id={`${id ? `${id}-${index}` : index}`}
                          key={index}
                          title={c.title}
                          items={c.items}
                          menu={menu}
                          slideEffect={c.slideEffect}
                        />
                      );
                    case "page.cards":
                      return (
                        <Cards
                          cardsAlignCenter={c?.cardsAlignCenter}
                          cardsText={c?.cardsText}
                          cardsTitle={c.cardsTitle}
                          cardsTitleAlign={c?.cardsTitleAlign}
                          cardsTitleHeadingLevel={c?.cardsTitleHeadingLevel}
                          items={c.items}
                          key={index}
                          layout={c.layout}
                          menu={menu}
                          numTileColumns={c?.numTileColumns}
                          withinContainer={c?.withinContainer}
                        />
                      );
                    case "page.tabs":
                      return (
                        <Tabs
                          title={c.title}
                          tabsId={c.tabsId}
                          items={c.elements}
                          key={index}
                        />
                      );
                    case "page.heading":
                      return (
                        <Heading
                          alignTitle={c?.alignTitle}
                          hTitleLevel={c?.hTitleLevel}
                          hTitleSeparator={c?.hTitleSeparator}
                          key={index}
                          title={c?.title}
                          subtitle={c?.subtitle}
                          subtitleLevel={c?.subtitleLevel}
                          withinContainer={c?.withinContainer}
                        />
                      );
                    case "page.image":
                      return (
                        <InlineImage
                          image={c?.image?.data?.attributes}
                          key={index}
                          alignment={c?.alignment}
                          size={c?.size}
                          style={c?.style}
                        />
                      );
                    default:
                      return null;
                  }
                })}
              </>
            )}
        </div>
      </div>
    </li>
  );
};

export default AccordionItem;
